<template>
    <div class="animated fadeIn">
       
        <b-card no-body class="h-100 w-100">
            
            <b-card-body :style="{backgroundColor: backgroundColor}">
                <b-container fluid class="p-0" >
                    <b-row>
                        <b-col  sm="12" lg="6" xl="8">
                           
                            <div class="mb-3" v-if="hasOneAvailableOrderType()">
                                <!-- <b-button-group class="w-100" v-if="!initializing">
                                    <b-button v-if="hideDineIn && orderTypeAvailablitiy[0].AllowOrderPickup == true"
                                        :disabled="disableOrderType"
                                        class="activeBtn"
                                        >Pickup | Takeout | Eat In</b-button>
                                    <b-button v-else-if="orderTypeAvailablitiy[0].AllowOrderPickup == true"
                                        :disabled="disableOrderType"
                                        class="activeBtn"
                                        >Pickup | Takeout</b-button>
                                    <b-button v-if="orderTypeAvailablitiy[1].AllowOrderDelivery ==true"
                                        :disabled="disableOrderType"
                                        class="activeBtn"
                                        >Delivery</b-button>
                                    <b-button v-if="orderTypeAvailablitiy[2].AllowOrderDinein == true"
                                        :disabled="disableOrderType"
                                        class="activeBtn"
                                        >Dine In</b-button>
                                </b-button-group>
                                <b-button-group class="w-100" v-else></b-button-group> -->
                            </div>
                            <div class="mb-3" v-else>
                                <b-button-group class="w-100" v-if="!initializing">
                                    <b-button v-if="hideDineIn"
                                        :disabled="disableOrderType"
                                        :class="orderTypeId === 1 ? 'activeBtn' : 'deactiveBtn'"
                                        @click="changeOrderType(1)">Pickup | Takeout | Eat In</b-button>
                                    <b-button v-else
                                        :disabled="disableOrderType"
                                        :class="orderTypeId === 1 ? 'activeBtn' : 'deactiveBtn'"
                                        @click="changeOrderType(1)">Pickup | Takeout</b-button>
                                    <b-button
                                        :disabled="disableOrderType"
                                        :class="orderTypeId === 3 ? 'activeBtn' : 'deactiveBtn'"
                                        @click="changeOrderType(3)">Delivery</b-button>
                                    <b-button
                                        v-if="!hideDineIn"
                                        :disabled="disableOrderType"
                                        :class="orderTypeId === 2 ? 'activeBtn' : 'deactiveBtn'"
                                        @click="changeOrderType(2)">Dine In</b-button>
                                </b-button-group>
                                <b-button-group class="w-100" v-else></b-button-group>
                            </div>

                            
                           


                            


                            <div v-if="orderTypeId === 1 && specialMenuTypeIds.length" >
                                <div class="d-flex flex-row">
                                    <span>
                                        Ordering from a special event menu?
                                    </span>
                                    <b-form-group label="" v-slot="{ ariaDescribedby }" class="mx-4">
                                        <b-form-radio-group
                                                v-model="isSpecial"
                                                :options="specialTypes"
                                                :aria-describedby="ariaDescribedby"
                                                name="plain-inline"
                                                @change="changeSpecialMode"
                                        ></b-form-radio-group>
                                    </b-form-group>
                                </div>
                                <b-form-group v-if="isSpecial">
                                    <b-input-group prepend="Special Event Menu">
                                        <b-form-select
                                            name="Special Event Menu"
                                            v-validate="'required'"
                                            @change="changeMenuType"
                                            :options="specialMenuTypeIds"
                                            text-field="MenuType"
                                            value-field="MenuTypeID"
                                            v-model="model.specialMenuTypeId"/>
                                    </b-input-group>
                                </b-form-group>
                            </div>

                            

                        <b-row :style="{'margin-top': !hasOneAvailableOrderType() ? '1.5rem' : '0'}">
                            <b-col cols="12" md="6">
                                    <template v-if="orderTypeId === 2">

                                    <div >
                                        <b-form-group v-if="servers.length">
                                            <b-input-group prepend="Server Name" >
                                                <b-form-select style="font-size: 1.1rem;" name="Server Name" value-field="fullName" text-field="fullName" :options="servers" v-model="model.ServerName"/>
                                            </b-input-group>
                                        </b-form-group>
                                        <b-form-group v-else class="font-weight-bold text-danger">
                                            No available any server client
                                        </b-form-group>
                                        <b-form-group>
                                            <b-input-group prepend="Table No">
                                                <b-input style="font-size: 1.1rem;" name="Table No" v-model="model.tableNumber" class="myFeild" v-validate="'required'" :placeholder="'Required'" />
                                            </b-input-group>
                                        </b-form-group>
                                    </div>
                                    </template>
                                    <template v-if="orderTypeId !== 2 && showTimes && showTimes.show">

                                        <b-form-group v-if="dates.length && isSpecial">
                                            <b-input-group :prepend="'Pickup Date'">
                                                <b-form-select
                                                    :name="'Pickup Date'"
                                                    v-validate="'required'"
                                                    :options="dates"
                                                    v-model="model.date"
                                                    @input="changeDate"
                                                />
                                            </b-input-group>
                                        </b-form-group>

                                        <b-form-group v-if="showTimes.show" >
                                            <b-input-group  :prepend="getTimeLabel">
                                                <b-form-select
                                                    :name="getTimeLabel"
                                                    style="font-size: 1.1rem;"
                                                    v-validate="'required'"
                                                    :options="times"
                                                    v-model="model.PickupTime"/>

                                            </b-input-group>
                                        </b-form-group>
                                        <div v-if="!showTimes.show">
                                            <p class="text-danger" v-if="orderTypeId === 1">
                                                No available pickup time exists.
                                            </p>
                                            <p class="text-danger" v-else>
                                                No available delivery time exists.
                                            </p>
                                        </div>
                                        

                                        
                                    </template>
                                    <template v-if="showAsap && orderTypeId === 1">
                                        <p style="font-size: 1.1rem; color: #ffffff;">
                                            Pickup Time: ASAP
                                        </p>
                                    </template>
                                    <div v-if="orderTypeId === 3" class="delivery-address-row mb-3">
                                        <b-btn variant="warning" class="delivery-address-btn" @click="showAddress = true">
                                            {{ hasConfirmedAddress ? 'Edit Address' : 'Add Address' }}
                                        </b-btn>
                                        <div v-if="hasConfirmedAddress" class="delivery-address-preview" :style="{'color': backgroundColorContrast+'!important'}">
                                            <div>
                                                {{ addressObject.preview.address }}<span v-if="model.deliveryUnitNo">, {{ model.deliveryUnitNo }}</span>
                                            </div>
                                            <div class="d-flex flex-wrap" style="column-gap: 2rem;">
                                                <span>{{ addressObject.preview.city }}, {{ addressObject.preview.prov || addressObject.preview.pc }}</span>
                                                <span v-if="model.deliveryIns">Note: {{ model.deliveryIns }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </b-col>
                                
                               
                                

                        
                                    <b-col cols="12" md="6" >

                                    <template v-if="showMainFields"> 
                                        
                                        <b-form-group >
                                            <b-input-group prepend="Customer Name" >
                                                <b-input style="font-size: 1.1rem;"  name="Customer Name" class="myFeild" optional placeholder="Optional" v-model="model.customerName" />
                                            </b-input-group>
                                        </b-form-group>
                                        <div v-if="showMainFields && orderTypeId !== 1" :class="orderTypeId === 2 ? 'mt-4' : 'mt-0'">
                                        
                                        <section :class="orderTypeId !== 2 ? 'pt-3' : 'pt-0'" @click="showPin = true" v-if="!showPin && orderTypeId !== 3" style="font-size: 1rem;" :style="{'color': backgroundColorContrast+'!important'}">
                                            Show phone verification
                                        </section>
                                        <section v-if="showPin || orderTypeId === 3">
                                            <b-form-group v-if="showCallFields">
                                                <phone-number
                                                        v-model="model.phoneNumber"
                                                        :orderType="orderTypeId"
                                                        :model="model"
                                                        @getMyKey="getMyKey"
                                                        name="Phone"
                                                />
                                            </b-form-group>
                                                        
                                            <b-form-group class="mb-0 " v-if="showCallFields && showPinCode" >
                                                <pin-code
                                                        v-model="verifyCode"
                                                        name="PIN Code"
                                                        :myIkey="myKeyCode"
                                                        :model="model"
                                                        :orderTypeId="orderTypeId"/>
                                            </b-form-group>
                                        
                                        </section>
                                    </div>
                                    </template>
                                </b-col>
                            </b-row>
                            <template v-if="showTimes && !showTimes.show && !showAsap && !times.length && orderTypeId !== 2">
                                <p class="text-danger" v-if="orderTypeId === 1">
                                    No available pickup time exists.
                                </p>
                                <p class="text-danger" v-else>
                                    No available delivery time exists.
                                </p>
                            </template>
                        <b-row>
                                <b-col cols="12" md="6">

                                    <div class="d-flex flex-row flex-wrap align-items-center" style="column-gap: 1rem;">
                                    
                                        <b-form-group v-if="orderTypeId === 1 && showMainFields" label="" v-slot="{ ariaDescribedby }" class="my-2">
                                            <b-form-radio-group
                                                    v-model="model.PackagingType"
                                                    :options="PackagingTypes"
                                                    :aria-describedby="ariaDescribedby"
                                                    name="Packaging type"
                                                    :style="{gap:'0'}"
                                                    size="lg"
                                                    buttons
                                                    button-variant="outline-warning"
                                            ></b-form-radio-group>
                                        </b-form-group>
                                        <b-button
                                                class="open-item-toggle my-2"
                                                :class="{ available: !openItemActive }"
                                                :variant="openItemActive ? 'warning' : 'light'"
                                                @click="$refs.addItem.toggleOpenItem()"
                                        >
                                            Open Item
                                        </b-button>
                                    </div>
                                    
                                
                                    </b-col>
                                    <b-col cols="12" md="6" >
                                        

                                    <div v-if="showMainFields && orderTypeId === 1" class="mt-2">
                                        
                                        <section class=" cursor-pointer pt-3" @click="showPin = true" v-if="!showPin" style="font-size: 1rem;" >
                                            <span :style="{'color': backgroundColorContrast+'!important'}">Show phone verification</span>
                                        </section>
                                        <section v-if="showPin">
                                            <b-form-group v-if="showCallFields">
                                                <phone-number
                                                        v-model="model.phoneNumber"
                                                        :orderType="orderTypeId"
                                                        :model="model"
                                                        @getMyKey="getMyKey"
                                                        name="Phone"
                                                />
                                            </b-form-group>
                                                        
                                            <b-form-group class="mb-0 " v-if="showCallFields && showPinCode" >
                                                <pin-code
                                                        v-model="verifyCode"
                                                        name="PIN Code"
                                                        :myIkey="myKeyCode"
                                                        :model="model"
                                                        :orderTypeId="orderTypeId"/>
                                            </b-form-group>
                                        
                                        </section>
                                    </div>
                                    </b-col>
                            </b-row>

                            <add-item
                    ref="addItem"
                    external-open-item-toggle
                    @open-item-toggled="openItemActive = $event"
                    :selectedOrderID="'selectedOrderID'"
                    @addItemFinaly="addItemFinaly"
                    @cancelAddItem="addModal = !addModal"
                    :byCreateTab="true"
                    :specialMenuType="isSpecial ? model.specialMenuTypeId : null"
                    :orderTypeId="orderTypeId"
                    :tag="false"
                    :specialStatus="isSpecial"
                    :currentTime="model.PickupTime"
                    :selectedItems="model.orderInfo"
                    :has-course="HasCourse"
                    :backgroundColorContrast="backgroundColorContrast"
                    :backgroundColor="backgroundColor"
                    
            />
                        </b-col>
                        <b-col  sm="10" lg="4" xl="4"  style="margin-left: auto">
                            
                            <div :style="{'background-color': backgroundColorContrast+'!important'}">
                                <b-table-simple v-if="model.orderInfo.length" class="mt-3" striped>
                                    <b-tbody>
                                        <b-tr v-for="(item, index) in model.orderInfo" @click="showEditItem(item, index)" :key="index">
                                            <td>
                                                {{item.Qty + 'x'}}
                                            </td>
                                            <td>
                                                <span v-if="item.CourseNo && HasCourse">
                                                    {{item.CourseNo}}
                                                </span>
                                            </td>
                                            <td class="">
                                                <p class="mb-0" :class="item.DrinkID !== 0 ? 'alcoholicText font-weight-bold' : 'text-dark'">
                                                    <span style="font-weight:bold; ">
                                                        {{item.Name}}
                                                    </span>
                                                    <span class="mb-0 ml-2" style="font-weight:bold; color:#78909C !important" v-if="allowSecondLang" :class="item.DrinkID !== 0 ? 'alcoholicText font-weight-bold' : 'text-dark'">
                                                    {{item.ItemName_SecondLang}}
                                                </span>
                                                    <span class="mx-5" v-if="item.Alcoholic">
                                                        * ALC. VERIFY AGE *
                                                    </span>
                                                </p>
                                                
                                                <p class="mb-0 font-weight-bold" style="color: #f9b300;">{{item.PriceComment}} <span v-if="allowSecondLang" class="ml-2" style="font-weight:bold; color:#78909C !important" >{{item.PriceComment_SecondLang}}</span></p>
                                                <p class="mb-0 font-weight-bold" style="color: red">
                                                    {{item.ModifierNames}}
                                                </p>
                                                <p  style="font-weight:bold;color:#78909C !important" class="mb-0 font-weight-bold" v-if="allowSecondLang" >
                                                    {{item.ModifierNamesSecondLang}}
                                                </p>
                                                <p v-if="item.DetailDescription != ''" style="color: #f9b300;" class="mb-0 font-weight-bold">Note: {{" "+item.DetailDescription}}</p>

                                            </td>
                                            <td>
                                                <b-btn variant="transparent" >
                                                    <font-awesome-icon icon="pencil-alt" class="align-middle text-dark"/>
                                                </b-btn>
                                            </td>
                                            <td>
                                                ${{item.totalPrice}}
                                            </td>
                                        </b-tr>
                                    </b-tbody>
                                    <b-tfoot>
                                        <b-tr  :style="{'background-color':model.orderInfo.length % 2 != 0 ?  backgroundColorContrast:'#f2f2f2'}">
                                            <b-td colspan="5" class="d-flex flex-column" v-if="creditApplied">
                                                <div :style="{'font-size':'1.2rem', 'text-decoration':'line-through',  'text-underline-offset': '-0.5rem'}" >
                                                    <span :style="{'font-weight':'bold', 'font-size':'1.2rem'}"> Sub Total: </span><span :style="{ 'font-size':'1.2rem'}"> ${{sumItemPrices()}}</span>
                                                </div> 
                                                <div class="">
                                                    
                                                    <span :style="{'font-weight':'bold', 'font-size':'1.2rem'}"> Sub Total (with ${{creditedAmmount()}} credited): </span><span :style="{ 'font-size':'1.2rem'}">${{sumItemPricesWithCredit()}}</span>                                        
                                                </div> 
                                            </b-td>
                                            <b-td colspan="5" v-else>
                                                <span :style="{'font-weight':'bold', 'font-size':'1.2rem'}"> Sub Total: </span><span :style="{ 'font-size':'1.2rem'}">${{sumItemPrices()}} </span>
                                            </b-td>
                                            
                                        </b-tr>
                                        
                                    </b-tfoot>
                                    
                                </b-table-simple>
                                
                                           
                                       
                            </div>
                            <div v-if="courseException()" class="text-danger font-weight-bold">
                                Error! Set missing course number(s) to proceed.
                            </div>
                            <span v-if="hideNote" :style="{'color': backgroundColorContrast}">Notes:</span>
                            <b-form-textarea v-if="hideNote" type="text" v-model="model.specialInstructions" class="w-100" style="height:4rem;"/>

                        </b-col>
                    </b-row>
                </b-container>
            </b-card-body>
            <b-card-footer > 
                <b-container fluid class="px-0">
                    <b-row>
                        <b-col cols="12" md="auto">
                            <b-btn cols="12" block md="auto" v-if="orderTypeId != 2 && sumItemPrices() > 0"  :style="isMobile ? 'margin:0.5rem 0!important;' : 'margin:0!important;'"
                                style="height:3rem!important; font-weight: bold;font-size: 1.1rem;" :variant="disabledPaymentButton ? 'secondary' : 'danger'" @click="paymentForm = !paymentForm" :disabled="disabledPaymentButton">
                                    Punch In Payment Card
                                    <font-awesome-icon icon="plus" class="align-middle mx-1"/>
                            </b-btn>
                            <b-btn cols="12" block md="auto" v-if="orderTypeId != 2 && sumItemPrices() == 0.00" :class="isMobile ? '' : ''" :style="isMobile ? '' : 'margin:0!important;'"
                                   style="height:3rem!important; font-weight: bold;font-size: 1.1rem;" :variant="disabledPaymentButton ? 'secondary' : 'danger'" @click="createOrder" :disabled="disabledPaymentButton">
                                    Submit Order
                            </b-btn>
                            <b-btn
                                    v-if="orderTypeId === 2"
                                    :class="isMobile ? '' : 'mb-2 mb-md-0 ml-sm-0'" :style="isMobile ? '' : 'margin:0!important;'"
                                   block @click="createOrder"
                                   style="height:3rem!important; font-weight: bold;font-size: 1.1rem;"
                                   :variant="disabledCreateOrderButton || loading || courseException() ? 'secondary' : 'danger'"
                                   :disabled="disabledCreateOrderButton || loading || courseException()">
                                <span >
                                    Create Tab (Keep Tab Open)
                                </span>
          
                            </b-btn>
                        </b-col>

                        

                        <b-col v-if="orderTypeId !== 2" cols="12" md="auto">
                            <b-btn block @click="createLink" :variant="disabledTextLinkButton ? 'secondary' : 'warning'" :disabled="disabledTextLinkButton"
                                   style="height:3rem!important; font-weight: bold;font-size: 1.1rem;"
                              :style="isMobile ? 'margin:0.5rem 0!important;' : ''" >
                                Text Payment Link
                            </b-btn>
                        </b-col>
                        <b-col cols="12" md="auto" class="my-0 " v-if="orderTypeId === 1 " >
                            <b-btn 
                            v-if="this.model.orderInfo.length > 0"
                                   style="height:5rem;padding:0 2rem;font-weight:bold; background-color:#000000!important;font-size: 1.1rem;"
                                   :style="isMobile ? 'margin:0.5rem 0!important;' : 'margin:0!important;' "
                                   block @click="cashPay"
                                   :variant="'primary'"
                                   :disabled="disableCashPayButton || loading || courseException() " >
                                   CASH Pay
                            </b-btn>
                        </b-col>
                        <b-col cols="12" md="auto" :class="isMobile ? 'ml-0' : 'ml-3 '" v-if="orderTypeId === 1 && this.model.orderInfo.length == 0 && !isMobile" >
                            <b-btn :class="isMobile ? 'my-2' : 'mb-2'"
                                   style="height:5rem;font-weight:bold;background-color:#000000!important;font-size: 1.1rem;"
                                   :style="isMobile ? '' : 'margin:0!important;'"
                                   block @click="openCashDrawerMode = true"
                                   :variant="'primary'">
                                   Open Cash Drawer
                            </b-btn>
                        </b-col>
                        <b-col cols="12" md="auto" :class="isMobile ? 'mx-0' : 'mx-4 '"  v-if="orderTypeId === 1 && hasCardReader" >
                            <b-btn class="mb-2 mb-md-0 "
                                   style="height:5rem;font-weight:bold;font-size: 1.1rem;"
                                   :style="isMobile ? '' : 'margin:0!important;'"
                                   block @click="cardReaderPay"
                                   :variant="'danger'"
                                   :disabled="disableCardReaderPayButton || loading || courseException() ">
                                   CARD READER Pay 
                                   
                            </b-btn>
                        </b-col>
                        <b-col cols="12" md="auto" :class="isMobile ? 'mx-0' : 'mx-4 '" v-if="orderTypeId === 1" >
                            <b-btn class="mb-2 mb-md-0"
                                   block @click="()=>{showCredit = true; canSoftRefresh = false}"
                                   style="height:3rem!important; font-weight: bold;font-size: 1.1rem;"
                                   :variant="'warning'"
                                   :disabled="disableCreditButton || loading || courseException() ">
                                   Give Credit (Comp & Discount)
                            </b-btn>
                        </b-col>
                        <b-col cols="12" md="auto" :class="isMobile ? 'mb-2 ml-0' : 'mb-2 mb-md-0 ml-4 ml-sm-0'" v-if="orderTypeId === 1" >
                            <b-btn class="mb-2 mb-md-0"
                                   block @click="otherPay"
                                   :variant="'primary'"
                                   style="background-color:#000000!important;;height:3rem!important; font-weight: bold;font-size: 1.1rem;"
                                   :disabled="disableOtherPayButton || loading || courseException() ">
                                   Other Pay
                            </b-btn>
                        </b-col>
                        <b-col cols="12" md="auto">
                            <b-btn block :class="isMobile ? 'my-2' : 'mb-2 mb-md-0 ml-4 ml-sm-0'" style="margin:0!important; font-weight: bold; height:3rem!important; font-weight: bold; background-color:#ffffff!important;font-size: 1.1rem;"
                             variant="outline-danger" @click="clear">
                                Clear Tab
                            </b-btn>
                        </b-col>
                    </b-row>
                </b-container>
            </b-card-footer>
        </b-card>

        
            


<!--        <b-modal body-class="p-0" size="lg" v-model="addModal" hide-header hide-footer>-->
<!--            -->
<!--        </b-modal>-->

        <c-modal v-model="editModal"
                 title="Edit Item"
                 size="xl"
                 cancel-label="Never mind"
                 hide-footer
                 :tag="false"
        >
            <edit-item-local
                :value="selectedItem"
                :isLocal="true"
                @cancelEditItem="editModal = !editModal"
                :itemIndex="itemIndex"
                @editItemFinaly="editItemFinaly"
                @deleteItem="deleteItem"
                :selectedItems="model.orderInfo"
                :has-course="HasCourse"
                :orderTypeId="orderTypeId"
            />
        </c-modal>

        <attention-remove-items v-model="attention" @submit="deleteAllItems"/>
        <clear-attention v-model="clearAttention" @clear="reset"/>
        <c-modal v-model="showAddress" :title="hasConfirmedAddress ? 'Edit Delivery Address' : 'Add Delivery Address'" size="md" @submit="saveAddress" :tag="false">
            <template #actions="{ submit, hide }">
                <b-row class="flex-grow-1">
                    <b-col cols="6">
                        <b-btn variant="warning" block class="text-nowrap delivery-modal-btn" @click="submit">Save</b-btn>
                    </b-col>
                    <b-col cols="6">
                        <b-btn variant="secondary" block class="text-nowrap delivery-modal-btn" @click="hide">Never mind</b-btn>
                    </b-col>
                </b-row>
            </template>
            <div>
                <b-form-group>
                    <autocomplete v-model="model.deliveryAddress" :address.sync="addressObject" :deliveryFeeType.sync="model.deliveryFeeType" v-validate="'required'" ref="address" @supportAddress="supportAddress => this.supportAddress = supportAddress" name="Address" />
                </b-form-group>
                <b-form-group>
                    <b-input-group prepend="Apt/Ste/Units">
                        <b-input v-model="model.deliveryUnitNo" name="Apt/Ste/Unit" class="myFeild" placeholder="Optional"/>
                    </b-input-group>
                </b-form-group>
                <b-form-group>
                    <b-input-group prepend="Delivery Instruction">
                        <b-input name="Delivery Instruction" v-model="model.deliveryIns" class="myFeild" placeholder="Optional"/>
                    </b-input-group>
                </b-form-group>
                <div class="d-flex flex-row align-items-center">
                    <b-btn variant="danger" @click="clearAddress">
                        Clear Address
                    </b-btn>
                    <div class="text-danger pl-2 font-weight-bold" v-if="model.deliveryAddress && supportAddress !== 'empty'">
                        <p v-if="supportAddress === 'support'" class="mb-0">
                            Address is within delivery zone.
                        </p>
                        <p v-else class="mb-0">
                            Address is outside of delivery zone.
                        </p>
                    </div>
                </div>
            </div>
        </c-modal>
                            
        <send-email
            v-model="sendEmail"
            @refresh="reset"
            :order="model"
            :tab-no="TabNo"
            :order-type-id="orderTypeId"
            :orderId="OrderId"
            :pay-type="payType"
            :order-items="model.orderInfo"
            :auto-confirm-pickup="AutoPaymentConfirm"
            :auto-confirm-delivery="AutoPaymentConfirm_Deliver"
            @printReceipt = "printReceipt"
            :printers="printers"
            :payBackCash="cashReturnAmmount"
        />
        <confirm-time
            v-model="confirmTime"
            :PreparationTime="PreparationTime"
            :opened="confirmTime"
            :byPass="byPassConfirmTimeManually"
            :order="model"
            :loading="loading"
            :EnableScheduledPickup="EnableScheduledPickup"
            :createLink="linkMode"
            @createPickUpOrder="createPickUpOrder"
            @createDeliveryOrder="createDeliveryOrder"
            @openConfirmMobile="openConfirmMobile"
        />
        
        <confirm-mobile
            v-model="confirmMobile"
            :order="model"
            :mobile="model.phoneNumber"
            :loading="loading"
            @createLinkPickup="createLinkPickup"
            @createLinkDineIn="createLinkDineIn"
            @createLinkDelivery="createLinkDelivery"
        />
        

        <payment-operation
        v-if="showCashPay"
        v-model="paymentForm"
            :order="createdOrderModel"
            @updateReport="updateReport"
            :Total="createdOrderModel.Total - createdOrderModel.Fee"
            :tab-no="createdOrderModel.TabNo"
            :table-no="createdOrderModel.TableNumber"
            @openCashBox="openCashBox"
            @getReceipt="getReceipt"
            :HasActiveReceiptPrinter="false"
            :HasActiveTicketPrinter="false"
            :cashOnly="true"
            @cancelPay="cancelPay"
            @setCashReturnAmmount="setCashReturnAmmount"
        />
    
        <payment-operation
        v-if="canShowCardReaderPayment && displayCardReaderPayment"
        v-model="paymentForm"
            :order="createdOrderModel"
            @updateReport="updateReport"
            :Total="createdOrderModel.Total - createdOrderModel.Fee"
            :tab-no="createdOrderModel.TabNo"
            :table-no="createdOrderModel.TableNumber"
            @openCashBox="openCashBox"
            @getReceipt="getReceipt"
            :HasActiveReceiptPrinter="false"
            :HasActiveTicketPrinter="false"
            :cardReaderOnly="true"
            @cancelPay="cancelPay"
        />
    
        <b-modal
            v-model="paymentForm"
            size="lg"
            centered
            hide-header
            hide-footer
            
        >
            <pay-card
                :customerName.sync="model.customerName"
                v-model="token"
                @createOrder="createOrder"
                @cancelOperation="paymentForm = false"
                
            />
        </b-modal>
        <Credit
            v-if="showCredit"
            :total="getTotal()"
            :model="creditModal"
            @hide="()=>showCredit=false"
            @apply="applyCredit"
        />
        <other-Pay
            v-if="showOtherPay"
            :open="showOtherPay"
            :otherPaySources="otherPaySources"
            @setReferenceID="setReferenceID($event)"
            @submit="otherPaySubmit($event)"
            @setOtherPaySource="setOtherPaySource($event)"
            @cancel="cancelPay"
            :total="createdOrderModel.Total - createdOrderModel.Fee"
            
        />
        <c-modal 
        v-model="openCashDrawerMode" 
        title="Open Cash Drawer"
        centered 
        :tag="false"
        size="md"
        @cancel="openCashDrawerMode = false"
        @submit="openCashDrawer"
        confirm-label="Yes, Open Cash Drawer"
        cancel-label="Never mind"
        >
            <div>
                <p class="pl-4 pt-2">Do you want to open cash drawer?</p>
            </div>
        </c-modal>
        <c-modal v-model="showCreditResetWarning"  centered :noSubmit="true" title="Credit Reset Warning" size="lg"  confirm-label="Got it" @submit="()=>{showCreditResetWarning = false; }" :tag="false">
            <div class="px-4">
                <p class="px-4 pt-2 text-center" style="font-size: 1.1rem;">The previously applied credit was removed because the tab amount changed.<br/>
                    Please reapply the credit if you still want it applied to this tab.</p>
            </div>
        </c-modal>
        
    </div>
</template>

<script>
    import EditForm from "./EditForm";
    import phoneNumber from "./components/phoneNumber";
    import PinCode from "./components/pinCode";
    import AttentionRemoveItems from "./components/attentionRemoveItems";
    import clearAttention from "./components/clearAttention";
    import SendEmail from "./components/SendEmail";
    import ConfirmTime from "./components/confirmTime";
    import confirmMobile from "./components/confirmMobile";
    import CModal from "../shared/Cmodal";
    import PaymentOperation from '../orders/paymentOperation'
    import Credit from "./components/Credit.vue";
    import otherPay from "./components/otherPay.vue";
    
    export default {
        name: 'createOrder',
        mixins: [EditForm],
        components: {
            CModal,
            ConfirmTime,
            AttentionRemoveItems,
            PinCode,
            phoneNumber,
            clearAttention,
            SendEmail,
            confirmMobile,
            PaymentOperation,
            Credit,
            otherPay
        },
        data(){
            return{
                model:{},
                openItemActive:false,
                canShowCardReaderPayment:false,
                displayCardReaderPayment:false,
                cardReaderPayInProgress:false,
                createdOrderModel:{},
                hideDineIn:false,
                initializing:false,
                showPinCode:false,
                hasCardReader:false,
                showCashPay:false,
                cashPayInProgress:false,
                byPassConfirmTimeManually:false,
                printers:[],
                creditApplied:false,
                creditModal:{
                    ammount:0,
                    reason:""
                },
                times:[],
                showCredit: false,
                showOtherPay:false,
                otherPayInProgress:false,
                orderCompleted:false,
                cashOrderCompleted:false,
                showCreditResetWarning:false,
                cashReturnAmmount:null,
                allowSecondLang:false,
                orderTypeId: 1,
                isSpecial: false,
                specialMenuTypeIds: [],
                canSoftRefresh: true,
                openCashDrawerMode: false,
                showAddress: false,
                addressConfirmed: false,
                backgroundColor: '#546E7A',
                backgroundColorContrast: '#FFFFFF',
                orderTypeAvailablitiy:[
                    {AllowOrderPickup: true},
                    {AllowOrderDelivery: true},
                    {AllowOrderDinein: true},
                ],
                otherPaySources: [],
                otherPaySource: null,
            }
        },
        mounted () {
            this.initialize()
        },
        
        watch: {
            '$store.state.selectedRestaurantId': {
                handler: function (newVal) {
                    if (newVal) {
                        this.getAllClients(newVal)
                        if (this.orderTypeId === 1) {
                            this.getRestaurantAllowance().then((res) => {
                                this.getOrderPreperation(newVal)
                                if (res) {
                                    
                                    this.getAllPickUpTime(newVal)
                                    this.showSpecialMenu(newVal).then(menuTypes => {
                                        this.specialMenuTypeIds = menuTypes
                                        if (menuTypes.length && this.isSpecial) {
                                            this.model.specialMenuTypeId = menuTypes[0].MenuTypeID
                                        } else {
                                            this.model.specialMenuTypeId = -1
                                        }
                                    })
                                }
                            })
                        } else if (this.orderTypeId === 3) {
                            this.dates = []
                            this.specialMenuTypeIds = []
                            this.getAllDeliveryTime(this.$store.state.selectedRestaurantId)
                        }
                    }
                },
                immediate: true
            },
           
            '$route.query.orderTypeId': {
                handler: function (newVal) {
                    this.orderTypeId = +newVal
                    if (+newVal === 1) {
                        this.showPin = false
                        this.changeSpecialMode(this.isSpecial)
                    } else if (+newVal === 2) {
                        this.dates = []
                        this.times = []
                    } else if (+newVal === 3) {
                        this.dates = []
                        this.specialMenuTypeIds = []
                        this.getAllDeliveryTime(this.$store.state.selectedRestaurantId)
                    }
                }
            }
        },
        computed: {
            isMobile(){
                return window.innerWidth < 768
            },
            hasConfirmedAddress () {
                return this.addressConfirmed && !!(this.addressObject && this.addressObject.preview)
            },
            getTimeLabel () {
                if (this.orderTypeId === 1) return 'Pickup Time'
                if (this.orderTypeId === 3) return 'Delivery Time'
            },
            disableCreditButton(){
                if(this.orderTypeId === 1 && this.model.orderInfo.length > 0 && this.sumItemPrices() > 0){
                    return false 
                }
                return true
            },
            disableCardReaderPayButton(){

                if(this.orderTypeId === 1 && this.model.orderInfo.length > 0 && this.sumItemPrices() > 0){
                    if(this.creditApplied && this.sumItemPricesWithCredit() == 0){
                        return true
                    }
                    return false 
                }
                
                return true
            },
            hideNote(){
                return this.model.orderInfo.length > 0
            },
            disableCashPayButton(){
                if(this.orderTypeId != 1 || !this.model.orderInfo.length ? true : false ){
                        return true
                }
                if(this.sumItemPrices() == 0.00)
                    return true
                return false
            },
            disableOtherPayButton(){
                if(this.orderTypeId != 1 || !this.model.orderInfo.length ? true : false ){
                        return true
                }
                if(this.sumItemPrices() == 0.00)
                    return true
                return false
            },
            disabledCreateOrderButton () {
                if (this.orderTypeId === 2) {
                    const isEmptyItems = !this.model.orderInfo.length ? true : false
                    const emptyTabNo = !this.model.tableNumber ? true : false
                    const emptyCustomerName = !this.model.customerName ? true : false
                    return isEmptyItems || emptyTabNo
                } else if (this.orderTypeId === 3) {
                    const isEmptyItems = !this.model.orderInfo.length ? true : false
                    const emptyCustomerName = !this.model.customerName ? true : false
                    const notSupport = this.supportAddress !== 'support' ? true : false
                    const noToken = !this.token ? true : false
                    const noDeliveryTimes = !this.times.length ? true : false
                    const unVerify = !this.verifyCode ? true : false
                    return isEmptyItems || emptyCustomerName || notSupport || noToken || noDeliveryTimes || unVerify
                } else if (this.orderTypeId === 1) {
                    const isEmptyItems = !this.model.orderInfo.length ? true : false
                    // const emptyCustomerName = !this.model.customerName ? true : false
                    // const noToken = !this.token ? true : false
                    // const unVerify = !this.verifyCode ? true : false
                    
                    return isEmptyItems //|| emptyCustomerName || noToken || unVerify
                       
                }
            },
            disabledTextLinkButton () {
                if (this.orderTypeId === 2) {
                    const isEmptyItems = !this.model.orderInfo.length ? true : false
                    const emptyTabNo = !this.model.tableNumber ? true : false
                    const emptyCustomerName = !this.model.customerName ? true : false
                    return isEmptyItems || emptyTabNo
                } else if (this.orderTypeId === 3) {
                    const isEmptyItems = !this.model.orderInfo.length ? true : false
                    const emptyCustomerName = !this.model.customerName ? true : false
                    const notSupport = this.supportAddress !== 'support' ? true : false
                    const unVerify = !this.verifyCode ? true : false
                    return isEmptyItems || emptyCustomerName || notSupport || unVerify
                } else if (this.orderTypeId === 1) {
                    const isEmptyItems = !this.model.orderInfo.length ? true : false
                    const unVerify = !this.verifyCode ? true : false
                    return isEmptyItems || unVerify
                    
                }
                
            },
            disabledPaymentButton () {
                if(this.creditApplied && this.sumItemPricesWithCredit() == 0){
                        return true
                    }
                if (this.orderTypeId === 1) {
                    const isEmptyItems = !this.model.orderInfo.length ? true : false
                    //const emptyCustomerName = !this.model.customerName ? true : false
                    //const unVerify = !this.verifyCode ? true : false
                    return isEmptyItems// || emptyCustomerName || unVerify
                      
                } else if (this.orderTypeId === 3) {
                    const isEmptyItems = !this.model.orderInfo.length ? true : false
                    const unVerify = !this.verifyCode ? true : false
                    const notSupport = this.supportAddress !== 'support' ? true : false
                    return isEmptyItems || notSupport || unVerify
                    // unVerify
                }
            },
            

        },
        
        beforeDestroy() {
            if(!window.location.pathname.includes('todaytickets')){
                this.exitFullscreen()
            }
        },
        methods: {
            getPackingTypes() {
                const object = {
                    RestaurantID: this.$store.state.selectedRestaurantId,
                }
                this.$api.publicClient.GetRestaurantInfo(object).then(res => {
                    if (!res.success) return

                    const packType = res.results.myPickupPackType

                    if (packType === 1) {
                        this.model.PackagingType = 'TO GO'
                    } else if (packType === 2) {
                        this.model.PackagingType = 'EAT IN'
                    }
                })
            },
            initialize(){
            this.enterFullscreen()
            this.getPrinters()
            this.getPackingTypes()
            let object = {
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    TableIKey: -1
                }
                this.$api.getRestaurant.GetRestaurantPOSs(object).then(res => {
                    if (res.success && res.results.length > 0) {
                        this.canShowCardReaderPayment = true
                        this.hasCardReader = true
                        
                    }
                })
            if (!this.$route.query.orderTypeId) {
                this.orderTypeId = 1
                this.$router.replace({ path: '/createOrder/index', query: { orderTypeId: 1 }})
            } else {
                this.orderTypeId = +this.$route.query.orderTypeId
                if (this.orderTypeId === 2) {
                    this.showPin = false
                    this.$router.replace({ path: '/createOrder/index', query: { orderTypeId: this.orderTypeId }})
                } else {
                    this.showPin = false
                    this.$router.replace({ path: '/createOrder/index', query: { orderTypeId: this.orderTypeId }})
                }
            }
            this.initializing = true
            const model = {
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    // UserID: localStorage.getItem('userID'),
                    MenutypeID: -1,
                    IsLive: 1,
                    Filter_OrderStatus: 3,
                    Search: '',
                    Sort: '',
                    Filter_ServerName: -1,
                    Filter_KDS: -1,
                    Serve_Type: "ToServe",
                    BlockSize: 8,
                    startIndex: 1
                }//just used to get allowsecondlang flag
                this.$api.getRestaurant.GetRestaurantOpenTickets(model).then(res => {
                    if (res.success) {
                        this.allowSecondLang = res.results.AllowSecondLang
                    }
                })
                let allowModel = {
                    RestaurantID: this.$store.state.selectedRestaurantId,
                }
                this.$api.getRestaurant.GetRestaurantAllowance(model).then((res) => {
                    if (res) {
                        console.log(res.results)
                        this.orderTypeAvailablitiy[0].AllowOrderPickup = res.results.AllowOrderPickup
                        this.orderTypeAvailablitiy[1].AllowOrderDelivery = res.results.AllowOrderDelivery
                        this.orderTypeAvailablitiy[2].AllowOrderDinein = res.results.AllowOrderDinein
                        if(this.hasOneAvailableOrderType()){
                            if(this.orderTypeAvailablitiy[0].AllowOrderPickup === true){
                                this.changeOrderType(1)
                            } else if(this.orderTypeAvailablitiy[1].AllowOrderDelivery === true){
                                this.changeOrderType(3)
                            } else if(this.orderTypeAvailablitiy[2].AllowOrderDinein === true){
                                this.changeOrderType(2)
                            }
                        }
                    }
                })


            return this.$api.getRestaurant.GetRestaurantProfile({RestaurantID: this.$store.state.selectedRestaurantId}).then((res) => {
                
                if (res.success) {
                    if(res.results.RestaurantType === "Fast Food" || res.results.RestaurantType === "Fast Casual"){
                        this.hideDineIn = true
                    }
                    if(res.OtherPaySources.length > 0){
                        this.otherPaySources = res.OtherPaySources
                    // Add "Other" as the first option
                    this.otherPaySources.push([5, "Other"]);
               
                    }else{
                        this.otherPaySources = []
                    }
                }

                this.initializing = false
                this.loading = false
        });  
            },
            enterFullscreen() {
                const el = document.documentElement;
                if (el.requestFullscreen) {
                    el.requestFullscreen().catch(err => {
                    // Browser blocked it (e.g., page loaded fresh with no prior gesture)
                    console.warn('Fullscreen request blocked:', err.message);
                    
                });
                }
            },
            exitFullscreen() {
                if (document.fullscreenElement) {
                    document.exitFullscreen();
                }
            },
            hasOneAvailableOrderType(){
                let trueCount = 0;
                this.orderTypeAvailablitiy.forEach(orderType => {
                    if(orderType.AllowOrderDelivery === true || orderType.AllowOrderDinein === true || orderType.AllowOrderPickup === true){
                        trueCount++
                    }
                });
                if(trueCount > 1){
                    return false
                }
                return true
            },
            onlyAvailableOrderType(){
                return this.orderTypeAvailablitiy.find(orderType => orderType.AllowOrderPickup === true || orderType.AllowOrderDelivery === true || orderType.AllowOrderDinein === true)

            },
            resetState(){
                    this.sendEmail = false
                    this.clearAttention = false
                    this.model.orderInfo = []
                    this.model.PackagingType="TO GO"
                    this.canShowCardReaderPayment = false
                    this.displayCardReaderPayment = false
                    this.cardReaderPayInProgress = false
                    this.createdOrderModel = {}
                    this.hideDineIn = false
                    this.initializing = false
                    this.showPinCode = false
                    this.hasCardReader = false
                    this.showCashPay = false
                    this.cashPayInProgress = false
                    this.byPassConfirmTimeManually = false
                    this.printers = []
                    this.creditApplied = false
                    this.model.customerName = ''
                    this.model.phoneNumber = ''
                    this.model.email = ''
                    this.model.address = ''
                    this.model.city = ''
                    this.model.state = ''
                    this.model.zip = ''
                    this.model.country = ''
                    this.model.specialInstructions = ''
                    this.model.tipNumber = 0
                    this.model.tableNumber = ''
                    this.model.ServerName = ''
                    this.model.PickupTime = null
                    this.model.date = null
                    this.model.orderType = ''
                    if(this.times.length > 0){
                        this.model.PickupTime = this.times[0].value
                    } else {
                        this.model.PickupTime = ''
                    }
                    this.model.submitOrder = true
                    this.creditModal = {
                        ammount: 0,
                        reason: ""
                    }
                    this.showCredit = false
                    this.showOtherPay = false
                    this.otherPayInProgress = false
                    this.orderCompleted = false
                    this.cashOrderCompleted = false
                    this.showCreditResetWarning = false
                    this.cashReturnAmmount = null
                    this.allowSecondLang = false
                    this.orderTypeId = 1
                    this.isSpecial = false
                    this.openCashDrawerMode = false
                    this.showAddress = false
                    this.addressConfirmed = false
                    if (this.$refs.address) this.$refs.address.clear()
                    this.model.deliveryAddress = ''
                    this.model.deliveryUnitNo = ''
                    this.model.deliveryIns = ''
                    this.addressObject = {}
                    this.supportAddress = 'empty'
                    this.specialMenuTypeIds = [],
                    this.otherPaySource = null,
                    this.referenceID = null
            },
            reset() {
                this.resetState()
                this.initialize()
            },
            saveAddress(){
                this.addressConfirmed = !!(this.addressObject && this.addressObject.preview)
                this.showAddress = false
            },
            cancelAddress(){
                this.$refs.address.clear()
                this.showAddress = false
                this.model.deliveryAddress = ''
                this.model.deliveryUnitNo = ''
                this.model.deliveryIns = ''
            },
            setCashReturnAmmount(amount){//called from cashPay -> payment op -> here
                
                this.cashReturnAmmount = amount
            },
            getTotal(){
                let total = 0
                this.model.orderInfo.forEach(el=>{
                    total+=parseFloat(el.totalPrice)
                })
                return parseFloat(total.toFixed(2))
            },
            applyCredit(obj){
                if(obj.ammount <=0){
                    this.creditModal.ammount = 0
                    this.creditModal.reason = ""
                    return this.creditApplied = false
                }
                this.creditModal.ammount = obj.ammount
                this.creditModal.reason = obj.reason
                return this.creditApplied = true
                
            },
            printReceipt(printerName=null){
               let tmp
               let printerIndex

               if(printerName){
                    tmp = this.printers.find(el=>el.PrinterName == printerName)
                    printerIndex = this.printers.indexOf(tmp)
               }

                const model = {
                        RestaurantID:this.$store.state.selectedRestaurantId,
                        OrderID:this.OrderId,
                        Type:"customer-receipt",
                        SelectedIds:[]
                    }
                    if(this.printers.length === 0 ){
                        return
                    }
                
                if(printerName && printerIndex){
                    model.SelectedIds[0] = {
                        IpAddress:this.printers[printerIndex].IPAddress,
                        Port: this.printers[printerIndex].Port,
                        
                    }   

                }else{
                    model.SelectedIds[0] = {
                        IpAddress:this.printers[0].IPAddress,
                        Port: this.printers[0].Port,
                        
                    }  
                }

                this.$api.getRestaurant.SendOrderPrintToApp(model).then(res=>{
                    
                    if(res.success){
                            this.reset()
                        }
                    })

            },
            getPrinters() {
                let model = {   
                    RestaurantID:this.$store.state.selectedRestaurantId,
                    UserID: localStorage.getItem('userID')
               }
                this.$api.getRestaurant.GetRestaurantPrinters(model).then(res => {
                    if (res.success) {
                        this.printers = res.results.RestaurantPrinter.filter(i => i.PrintTaskID === 2)
                        
                    }
                })
            },
            getReceipt(){
                this.cashOrderCompleted = true
                this.loading = false
                this.sendEmail = true
                return 
            },
            updateReport(){
                this.sendEmail = true
                this.cashOrderCompleted = true
        
                this.loading = false
                
                return
            },
            openCashDrawer(){
                this.openCashBox()
                this.openCashDrawerMode = false
            },
            openCashBox(){
                const model ={
                    RestaurantID: localStorage.getItem('selectedRestaurant'),
                    IpAddress:this.printers[0].IPAddress
                }
                this.$api.getRestaurant.SendFireBaseOpenCashBoxMessage(model).then(res=>{
                    
                }).catch(()=>{console.log('could not open cash box')})
                
            },
            cancelPay(){
                this.showOtherPay = false
                this.canShowCardReaderPayment = false
                this.showCashPay =false
                this.loading = false
                this.cardReaderPayInProgress = false
                this.cashPayInProgress = false
                this.otherPayInProgress = false
                this.paymentForm = false
                document.body.classList.remove('modal-open');

                if(!this.cashOrderCompleted && !this.orderCompleted){
                    this.createdOrderModel = {}
                    let model = {
                        UserID:localStorage.getItem('userID'),
                        RestaurantID:localStorage.getItem('selectedRestaurant'),
                        OrderID:this.OrderId
                    }
                    this.$api.getRestaurant.DeleteRestaurantOrder(model).then(res=>{
                        if(this.model.customerName == 'NO NAME'){
                            this.model.customerName = ''
                        }
                        if(!res.success){
                            this.$showError("Order Not Updated!! , Please Refresh the page.")
                        }
                        
                    })
                }
            },
            courseException () {
                const items = this.model.orderInfo
                if (items.length) {
                    const allHaveCourse = items.every(item => item.CourseNo)
                    const allNotHaveCourse = items.every(item => !item.CourseNo)
                    if (allHaveCourse || allNotHaveCourse) {
                        return false
                    } else {
                        return true
                    }
                } else {
                    return false
                }
            },
            getMyKey (myKeyCode) {
                this.myKeyCode = myKeyCode
                this.showPinCode = true
            },
            slideChange (s) {
                if (s.realIndex === 0) {
                    this.orderTypeId = 1
                    this.$router.push(`?orderTypeId=${this.orderTypeId}`)
                } else if (s.realIndex === 1) {
                    this.orderTypeId = 3
                    this.$router.push(`?orderTypeId=${this.orderTypeId}`)
                } else if (s.realIndex === 2) {
                    this.orderTypeId = 2
                    this.$router.push(`?orderTypeId=${this.orderTypeId}`)
                }
            },
            goPrevSlide () {
                const {activeIndex} = this.$refs.slider.$swiper
                if (activeIndex === 0) {
                    this.$refs.slider.$swiper.slideTo(2)
                } else if (activeIndex === 1) {
                    this.$refs.slider.$swiper.slideTo(0)
                } else if (activeIndex === 2) {
                    this.$refs.slider.$swiper.slideTo(1)
                }
            },
            goNextSlide () {
                const {activeIndex} = this.$refs.slider.$swiper
                if (activeIndex === 0) {
                    this.$refs.slider.$swiper.slideTo(1)
                } else if (activeIndex === 1) {
                    this.$refs.slider.$swiper.slideTo(2)
                } else if (activeIndex === 2) {
                    this.$refs.slider.$swiper.slideTo(0)
                }
            },
            getAllClients (RestaurantID) {
                const filter = {
                    RestaurantID,
                    // UserID: localStorage.getItem('userID')
                }
                this.servers = []
                return this.$api.getRestaurant.GetDashboardRestaurantClient(filter).then(res => {
                    if (res.success) {
                        res.RestaurantClients.forEach(item => {
                            item.fullName = item.FirstName + ' ' + item.LastName
                        })
                        const available = res.RestaurantClients.filter(i => i.Role.includes('Restaurant Server'))
                        this.servers = [{fullName: localStorage.getItem('userInfo')}, ...available]
                        if (this.servers.length) {
                            this.model.ServerName = this.servers[0].fullName
                        }
                    }
                }).catch(() => {})
            },
            changeOrderType (orderTypeId) {
                this.orderTypeId = orderTypeId
                this.showPin = false
                
                if (this.$route.query.orderTypeId != orderTypeId.toString()) {
                    this.$router.push(`?orderTypeId=${orderTypeId}`)
                    this.resetState()
                    this.initialize()
                }
                return
                
                
            },
            clearAddress () {
                this.$refs.address.clear()
            },
            addItemFinaly (data) {
                if(this.creditApplied){
                    this.resetCredit()
                }
                this.addModal = false
                this.addModal = true
                this.model.orderInfo.push(data)
            },
            showEditItem (item, index) {
                this.selectedItem = item
                this.itemIndex = index
                this.editModal = true
            },
            deleteItem (n) {
                if(this.creditApplied){
                    this.resetCredit()
                }
                this.model.orderInfo.splice(n, 1)
                this.editModal = false
            },
            resetCredit(){
                this.showCreditResetWarning = true
                this.creditApplied = false
                this.creditModal.ammount = 0
                this.creditModal.reason = ""
            },
            editItemFinaly (data) {
                if(this.model.orderInfo[data.itemIndex].Qty != data.model.Qty && this.creditApplied){
                    this.resetCredit()
                }
                this.model.orderInfo[data.itemIndex] = data.model
                this.editModal = false
            },
            sumItemPrices () {
                return this.model.orderInfo.reduce(function (acc, current) {
                    return (Number(acc) + Number(current.totalPrice)).toFixed(2)
                }, 0);
            },
            sumItemPricesWithCredit () {
                let total = this.model.orderInfo.reduce(function (acc, current) {
                     return (Number(acc) + Number(current.totalPrice)).toFixed(2)
                }, 0);
                 
                return (total - this.creditModal.ammount).toFixed(2)

            },
            creditedAmmount(){
                
                return parseFloat(this.creditModal.ammount).toFixed(2)
            },
            
            deleteAllItems () {
                this.model.orderInfo = []
                this.attention = false
                this.$nextTick(() => {
                    this.isSpecial = !this.isSpecial
                    this.changeSpecialMode(this.isSpecial)
                })
            },
            cardReaderPay(){
                this.canSoftRefresh = false
                this.cardReaderPayInProgress = true
                this.canShowCardReaderPayment = true
                this.byPassConfirmTimeManually = true
                this.createOrder()
            },
            otherPay(){
                this.canSoftRefresh = false
                this.otherPayInProgress = true
                this.showOtherPay = true
                if(this.showAsap && this.orderTypeId === 1){
                    this.byPassConfirmTimeManually = true
                }
               
                this.createOrder()
            },
            otherPaySubmit(){
                this.orderCompleted = true
                let model = {}
                if(!this.otherPaySource){
                 model = {
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    OrderID: this.OrderId,
                    PaymentStatusID:5
                }
                }else{
                    model = {
                        RestaurantID: this.$store.state.selectedRestaurantId,
                        OrderID: this.OrderId,
                        PaymentStatusID:this.otherPaySource,
                        
                    }
                }
                if(this.referenceID){
                    model.OtherPayTransaction = this.referenceID
                }
                return this.$api.getRestaurant.UpdateOrderCashPaid(model).then(res=>{
                    if(res.success){
                        this.showOtherPay =false

                        this.sendEmail = true
                    }
                })
                

            },
            setOtherPaySource(source){
                this.otherPaySource = source
            },
            setReferenceID(referenceID){
                console.log(referenceID)
                this.referenceID = referenceID
            },
            cashPay(){
                this.canSoftRefresh = false
                this.showCashPay = true
                this.byPassConfirmTimeManually = true
                this.cashPayInProgress = true
                this.createOrder()
                
            },
            createOrder () {
                if (this.orderTypeId === 1) {
                    const model = {...this.model}
                    
                    model.specialMenuTypeId = !this.isSpecial ? -1 : model.specialMenuTypeId
                    model.orderType = this.orderTypeId
                    if (this.orderTypeId === 1 &&  !model.customerName) {
                        model.customerName = 'NO NAME'
                    }
                    this.model = model
                    this.linkMode = false
                    this.payType = 'card'

                   this.confirmTime = false 
                   this.confirmTime = true
                    if(this.paymentForm)
                        this.paymentForm = false
                } else if (this.orderTypeId === 2) {
                    const model = {...this.model}
                    if (!model.customerName) {
                        model.customerName = 'NO NAME'
                    }
                    this.linkMode = false
                    this.payType = 'card'
                    this.model = model
                    this.createDineInOrder()
                } else if (this.orderTypeId === 3) {
                    const model = {...this.model}
                    const {address, city, pc} = this.addressObject.preview
                    model.deliveryAddress = address + ',' + city + ',' + pc
                    model.deliveryCity = city
                    model.deliveryZip = pc
                    model.specialMenuTypeId = -1
                    model.orderType = this.orderTypeId
                    this.model = model
                    this.linkMode = false
                    this.payType = 'card'
                    this.confirmTime = true
                    if(this.paymentForm)
                        this.paymentForm = false
                }
            },
            createDineInOrder () {
                const model = {...this.model}
                model.RestaurantID = this.$store.state.selectedRestaurantId
                model.orderType = this.orderTypeId
                model.orderInfo.forEach(item => {
                    item.OrderID = 0
                    if (!item.ModifierIDs) {
                        item.ModifierIDs = '#'
                    }
                })
                if (model.phoneNumber) {
                    model.phoneNumber = '+1' + model.phoneNumber
                }
                model.PackagingType = ''
                model.PickupTime = ''
                model.specialMenuTypeId = -1
                model.deliveryFeeType = ''
                this.loading = true
                return this.$api.getRestaurant.CreateOrder(model).then(res => {
                    this.loading = false
                    if (res.success) {
                        this.TabNo = res.orderInfo.TabNo
                        this.OrderId = res.orderInfo.OrderID
                        this.sendEmail = true
                    } else {
                        this.$showError(res.message)
                    }
                }).catch(() => {
                    this.loading = false
                })
            },
            createPickUpOrder (model) {
                this.confirmTime = false
                if (model.phoneNumber == '') {
                    model.phoneNumber = ''
                } else {
                    model.phoneNumber = '+1' + model.phoneNumber.replace(/-/g, '')
                }
                model.orderType = this.orderTypeId
                model.orderInfo.forEach(item => {
                    item.OrderID = 0
                    if (!item.ModifierIDs) {
                        item.ModifierIDs = '#'
                    }
                })
                if(this.cardReaderPayInProgress || this.cashPayInProgress || this.otherPayInProgress)
                    model.submitOrder = false
                else
                    model.submitOrder = true
                model.deliveryFeeType = ''
                model.ServerName = ''
                model.tableNumber = '5445'
                model.RestaurantID = this.$store.state.selectedRestaurantId
                model.deliveryAddress = ''
                model.deliveryCity = ''
                model.deliveryZip = ''
                this.loading = true
                return this.$api.getRestaurant.CreateOrder(model).then(res => {
                    if (res.success) {
                        if(this.creditApplied && this.creditModal.ammount != 0){
                            const model = {
                                RestaurantID: this.$store.state.selectedRestaurantId,
                                OrderID: res.orderInfo.OrderID,
                                Credit: this.creditedAmmount(),
                                Reason: this.creditModal.reason
                            }
                            let tmpRes = res
                            this.$api.getRestaurant.UpdateOrderCredit(model)
                                .then(res => {
                                    if (!res.success){ 
                                        
                                            this.$showError("failed to apply credit!!!")
                                    }else{//if credit is applied we have to wait for backend to update total, same code as below
                                        if(this.cardReaderPayInProgress || this.showCashPay || this.otherPayInProgress){//paying with reader can only be true in takeout
                                            this.TabNo = tmpRes.orderInfo.TabNo
                                            this.OrderId = tmpRes.orderInfo.OrderID
                                            
                                            let model={
                                                RestaurantID: this.$store.state.selectedRestaurantId,
                                                OrderID:tmpRes.orderInfo.OrderID,
                                            }

                                            return this.$api.getRestaurant.GetRestaurantCurrentOrders(model).then(res => {
                                                if (res.success) {
                                                    this.createdOrderModel = res.orderInfo

                                                    if(!this.showCashPay && !this.showOtherPay){
                                                        this.displayCardReaderPayment = true
                                                    }
                                                }
                                            })

                                        }else{//cash pay
                                            this.TabNo = tmpRes.orderInfo.TabNo
                                            this.OrderId = tmpRes.orderInfo.OrderID
                                            if(this.sumItemPrices() == 0.00){
                                                let model = {
                                                    RestaurantID: this.$store.state.selectedRestaurantId,
                                                    OrderID: tmpRes.orderInfo.OrderID,
                                                    PaymentStatusID:4
                                                }
                                                return this.$api.getRestaurant.UpdateOrderCashPaid(model).then(res=>{
                                                    if(res.success){
                                                        this.sendEmail = true
                                                    }
                                                })
                                            
                                            }

                                            this.addPayment(res.orderInfo)
                                        }   
                                                    }
                            })
                                .catch((err) => {
                                    this.$showError(err)
                                })
                            }
 
                        
                        else if(this.cardReaderPayInProgress || this.showCashPay || this.otherPayInProgress){//paying with reader can only be true in takeout
                            this.TabNo = res.orderInfo.TabNo
                            this.OrderId = res.orderInfo.OrderID
                            
                            let model={
                                RestaurantID: this.$store.state.selectedRestaurantId,
                                OrderID:res.orderInfo.OrderID,
                            }

                            this.$api.getRestaurant.GetRestaurantCurrentOrders(model).then(res => {
                                if (res.success) {
                                    this.createdOrderModel = res.orderInfo

                                    if(!this.showCashPay && !this.showOtherPay){
                                        this.displayCardReaderPayment = true
                                    }
                                }
                            })

                        }else{//cash pay
                            this.TabNo = res.orderInfo.TabNo
                            this.OrderId = res.orderInfo.OrderID
                            if(this.sumItemPrices() == 0.00){
                                let model = {
                                    RestaurantID: this.$store.state.selectedRestaurantId,
                                    OrderID: res.orderInfo.OrderID,
                                    PaymentStatusID:4
                                }
                                return this.$api.getRestaurant.UpdateOrderCashPaid(model).then(res=>{
                                    if(res.success){
                                        this.sendEmail = true
                                    }
                                })
                               
                            }

                            this.addPayment(res.orderInfo)
                        }   
                       
                    } else {
                        this.loading = false
                        this.$showError(res.message)
                    }
                }).catch(() => {
                    this.loading = false
                })
            },
            createDeliveryOrder(model) {
                model.phoneNumber = '+1' + model.phoneNumber.replace(/-/g, '')
                model.orderType = this.orderTypeId
                model.orderInfo.forEach(item => {
                    item.OrderID = 0
                    if (!item.ModifierIDs) {
                        item.ModifierIDs = '#'
                    }
                })
                model.ServerName = ''
                model.tableNumber = '5445'
                model.PackagingType = ''
                model.RestaurantID = this.$store.state.selectedRestaurantId
                this.loading = true
                return this.$api.getRestaurant.CreateOrder(model).then(res => {
                    if (res.success) {
                        this.TabNo = res.orderInfo.TabNo
                        this.OrderId = res.orderInfo.OrderID
                        this.addPayment(res.orderInfo)
                        // this.sendEmail = true
                    } else {
                        this.loading = false
                        this.$showError(res.message)
                    }
                }).catch(() => {
                    this.loading = false
                })
            },

            createLink () {
                this.canSoftRefresh = false
                if (this.orderTypeId === 1) {
                    const model = {...this.model}
                    model.specialMenuTypeId = !this.isSpecial ? -1 : model.specialMenuTypeId
                    model.orderType = this.orderTypeId
                    this.model = model
                    this.linkMode = true
                    this.payType = 'link'
                    this.confirmTime = true
                } else if (this.orderTypeId === 2) {
                    const model = {...this.model}
                    model.specialMenuTypeId = -1
                    model.deliveryAddress = ''
                    model.deliveryCity = ''
                    model.deliveryZip = ''
                    model.PickupTime = ''
                    model.orderType = this.orderTypeId
                    this.model = model
                    this.linkMode = true
                    this.payType = 'link'
                    this.confirmMobile = true
                } else if (this.orderTypeId === 3) {
                    const model = {...this.model}
                    const {address, city, pc} = this.addressObject.preview
                    model.deliveryAddress = address + ',' + city + ',' + pc
                    model.deliveryCity = city
                    model.deliveryZip = pc
                    model.specialMenuTypeId = -1
                    model.orderType = this.orderTypeId
                    this.model = model
                    this.linkMode = true
                    this.payType = 'link'
                    this.confirmTime = true
                }
            },

            openConfirmMobile (model) {
                this.model = model
                this.confirmTime = false
                this.confirmMobile = true
            },

            createLinkPickup (model) {
                model.phoneNumber = '+1' + model.phoneNumber.replace(/-/g, '')
                model.orderType = this.orderTypeId
                model.orderInfo.forEach(item => {
                    item.OrderID = 0
                    if (!item.ModifierIDs) {
                        item.ModifierIDs = '#'
                    }
                })
                model.deliveryFeeType = ''
                model.ServerName = ''
                model.tableNumber = '5445'
                model.RestaurantID = this.$store.state.selectedRestaurantId
                model.deliveryAddress = ''
                model.deliveryCity = ''
                model.deliveryZip = ''
                if(model.customerName === "")
                    model.customerName = "No Name"
                this.loading = true
                return this.$api.getRestaurant.CreateOrder(model).then(res => {
                    if (res.success) {
                        this.TabNo = res.orderInfo.TabNo
                        this.OrderId = res.orderInfo.OrderID
                        this.createUrl(model)
                    } else {
                        this.loading = false
                        this.$showError(res.message)
                    }
                }).catch(() => {
                    this.loading = false
                })
            },
            createLinkDineIn (model) {
                model.orderType = this.orderTypeId
                model.orderInfo.forEach(item => {
                    item.OrderID = 0
                    if (!item.ModifierIDs) {
                        item.ModifierIDs = '#'
                    }
                })
                model.phoneNumber = '+1' + model.phoneNumber.replace(/-/g, '')
                model.PackagingType = ''
                model.PickupTime = ''
                model.specialMenuTypeId = -1
                model.deliveryFeeType = ''
                model.RestaurantID = this.$store.state.selectedRestaurantId
                this.loading = true
                return this.$api.getRestaurant.CreateOrder(model).then(res => {
                    if (res.success) {
                        this.TabNo = res.orderInfo.TabNo
                        this.OrderId = res.orderInfo.OrderID
                        this.createUrl(model)
                    } else {
                        this.$showError(res.message)
                        this.loading = false
                    }
                }).catch(() => {
                    this.loading = false
                })
            },
            createLinkDelivery (model) {
                model.phoneNumber = '+1' + model.phoneNumber.replace(/-/g, '')
                model.orderType = this.orderTypeId
                model.orderInfo.forEach(item => {
                    item.OrderID = 0
                    if (!item.ModifierIDs) {
                        item.ModifierIDs = '#'
                    }
                })
                model.ServerName = ''
                model.tableNumber = '5445'
                model.PackagingType = ''
                model.RestaurantID = this.$store.state.selectedRestaurantId
                this.loading = true

                return this.$api.getRestaurant.CreateOrder(model).then(res => {
                    if (res.success) {
                        this.TabNo = res.orderInfo.TabNo
                        this.OrderId = res.orderInfo.OrderID
                        this.createUrl(model)
                    } else {
                        this.loading = false
                        this.$showError(res.message)
                    }
                }).catch(() => {
                    this.loading = false
                })
            },
            createUrl (order) {
                let model = {
                    // UserID: localStorage.getItem('userID'),
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    PhoneNumber: (order.phoneNumber.replace(/-/g, '')),
                    OrderID: this.OrderId
                }
                return this.$api.getRestaurant.GetOrderPaymentURL(model).then(res => {
                    if (res.success) {
                        this.SendPaymentURL(order)
                    } else {
                        this.loading = false
                        this.$showError(res.message)
                    }
                }).catch(() => {
                    this.loading = false
                })
            },
            SendPaymentURL (order) {
                let model = {
                    PhoneNumber: (order.phoneNumber.replace(/-/g, '')),
                    OrderID: this.OrderId,
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    TabNumber: this.TabNo
                }
                return this.$api.diner.SendPaymentURL(model).then(res => {
                    if (res.success) {
                        this.loading = false
                        this.confirmMobile = false
                        this.sendEmail = true
                    } else {
                        this.loading = false
                        this.$showError(res.message)
                    }
                }).catch(err => {
                    this.loading = false
                })
            },
            clear () {
                this.clearAttention = true
            },

        }
    }
</script>

<style scoped>
.input-group-text {
    font-size: 1.1rem !important;
}
.delivery-address-row {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 0.5rem 1rem;
}
.delivery-address-btn {
    min-width: 14rem;
    font-size: 1.2rem;
    font-weight: 500;
    border: 2px solid #ffffff;
}
.delivery-address-preview {
    flex: 1 1 12rem;
    min-width: 0;
    font-size: 1.2rem;
    line-height: 1.4;
    overflow-wrap: anywhere;
}
.delivery-modal-btn {
    font-size: 1.2rem;
}
@media (max-width: 575px) {
    .delivery-address-btn {
        width: 100%;
        min-width: 0;
    }
}
    .activeBtn {
        background: #f5c31d !important;
        border-color: #c8ced3 !important;
        font-weight: bold;
    }
    .deactiveBtn {
        background: #fff !important;
        border-color: #c8ced3 !important;
        color: #c8ced3 !important;
        font-weight: bold;
    }
    .item-box{
        border-left: 1px solid #cbcbcb;
    }
    @media only screen and (max-width: 992px) {
        .item-box{
            border-left: 0;
            border-top: 1px solid #cbcbcb;
        }
    }
    .alcoholicText {
        color: #3d5afe;
    }
    .open-item-toggle {
        width: 10rem;
        height: 2.75rem;
        font-weight: bold;
        border-radius: 0.35rem;
    }
    .available {
        background: #fff !important;
        border-color: #464b50 !important;
        color: #464b50 !important;
    }
</style>
